import React from 'react'
import { Link } from 'react-router'
import BgImage from '../../assets/images/Footer/sub-footer-bg-image-1.png';

const SpecialFooterBar = () => {
    return (
        <>
            <section
                className="mx-3 mb-3 block1"
                style={{
                    backgroundImage: `url(${BgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <div className="bg-black/5 shadow-md p-8">

                    {/* <!-- Call-to-Action Content --> */}
                    <div className="flex flex-wrap items-center justify-center gap-6">
                        {/* <!-- Contact Info --> */}
                        <div className="text-center lg:text-left">
                            <p className="text-lg text-gray-800 text_CormorantGaramond-Regular uppercase font-bold">
                                {/* Looking for consultation? Contact us here. */}
                                Looking for consultation? Call us.
                                {/* <a href="#" className="font-semibold hover:underline">
                                    +94 12 344 4578
                                </a> */}
                            </p>
                        </div>
                        {/* <!-- CTA Title --> */}
                        <div className="text-center lg:text-left">
                            {/* <h3 className="text-xl font-bold text-gray-800">
                                We are <span className="text-skincolor">certified</span> ayurved company
                            </h3> */}
                        </div>
                    </div>
                    {/* <!-- Button --> */}
                    <div className="mt-3 text-center">
                        <h4 className="text-xl  text-gray-800 text_OpenSans-VariableFont_wdth">
                            <a href='tel:+9471 062 2696'>
                                +9471 062 2696
                            </a>
                            {/* +9471 062 2696 */}
                        </h4>
                        {/* <Link
                            to={'/Contact-us'}
                            className="inline-block border-2 border-customMaroon-40 text-customMaroon-25 font-medium text-lg py-3 px-8 rounded-full hover:bg-customBrass-50 hover:text-white transition duration-300 ml-5"
                        >
                            Contact us
                        </Link> */}
                    </div>
                </div>
            </section>
        </>
    )
}

export default SpecialFooterBar